<template>
    <div class="TopCharts">
        <div class="left">
            <PublicEcharts id="topChartsLeft" :chartsData="orderDataLeft" :options="dealRingData()" usePropsOptions />
        </div>
        <div class="right">
            <PublicEcharts id="topChartsRight" :options="dealOptionRight()" usePropsOptions />
        </div>
    </div>
</template>

<script>
import PublicEcharts from "@/components/PublicEcharts";
import { dealBigNum, amountFun } from "@/assets/js/utils";
export default {
    name: "TopCharts",
    props: {},
    components: { PublicEcharts },
    data() {
        return {
            orderDataLeft: { name: '整体进度', value: 76.3 },
            orderDataRight: [{ "name": "待建设", "value": 3 },
            { "name": "已建设", "value": 11 },
            { "name": "建设中", "value": 7 },
            ],
        }
    },
    computed: {},
    methods: {
        dealBigNum,
        amountFun,
        dealRingData() {
            const { value } = this.orderDataLeft;
            let optionDefault = {
                title: {
                    text: `${value}%`,
                    x: "center",
                    y: "35%",
                    textStyle: {
                        color: "#fff",
                        fontSize: 20,
                        align: "center",
                    },
                    subtext: "整体进度",
                    subtextStyle: {
                        fontSize: 12,
                        color: "#16E9F4",
                    },
                    // textVerticalAlign:'middle',
                },
                tooltip: {
                    show: false
                },
                legend: {
                    show: false
                },
                color: ['#28CCCB', '#284360'],
                series: [
                    {
                        type: "pie",
                        radius: ["55%", "75%"],
                        cursor: 'default',
                        data: [{
                            name: '整体进度',
                            value,
                            emphasis: {
                                disabled: true
                            },
                            itemStyle: {
                                //  线性渐变方式一 ======================================================
                                // LinearGradient前四个分参数别代表右，下，左，上，数值0-1
                                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    {
                                        offset: 0,
                                        color: 'rgba(22, 233, 244, 1)'
                                    },
                                    {
                                        offset: value / 100,
                                        color: 'rgba(8, 150, 233, 1)'
                                    }
                                ])
                            }
                        }, {
                            name: '总数',
                            value: 100 - value,
                            emphasis: {
                                disabled: true
                            },
                            itemStyle: {
                                color: '#284360'
                            }
                        }],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                        label: {
                            show: false
                        },
                    },
                ],
            };
            return optionDefault
        },
        dealOptionRight() {
            const paramData = this.orderDataRight
            let tol = 0;
            tol = amountFun(paramData)
            const option = {
                title: {
                    text: tol == 0 ? "0" : tol,
                    x: "center",
                    y: "35%",
                    textStyle: {
                        color: "#fff",
                        fontSize: 20,
                        align: "center",
                    },
                    subtext: "总数",
                    subtextStyle: {
                        fontSize: 12,
                        color: "#16E9F4",
                    },
                    // textVerticalAlign:'middle',
                },
                tooltip: {
                    trigger: "item",
                    formatter: function (param) {
                        return `${param.name}:${dealBigNum(param.value)} ${param.percent == undefined ? 0 : param.percent}%`
                    },
                },
                legend: {
                    show: false
                },
                color: [
                    "#26D9D4",
                    "#F2D397",
                    "#4398EB",
                    "#74AE8B",
                    "#636CCA",
                    "#E48784",
                    "#ACCBE1",
                    "#D2E5D2",
                    "#A68CD7",
                    "#B49590",
                ],
                series: [
                    {
                        type: "pie",
                        radius: ["55%", "75%"],
                        data: paramData,
                        // minAngle: 10, // label最小扇区大小
                        label: {
                            bleedMargin:0,
                            alignTo: "edge", // label两端对称布局
                            edgeDistance: 10, // 布局为两端对称时候需要外边距防止图表变形 数值随意不要太大
                            distanceToLabelLine: -30, // label距离引导线距离
                            formatter: function (param) {
                                return (
                                    "{a|" +
                                    (param.percent == undefined ? 0 : param.percent) +
                                    "%" +
                                    "}\n{hr|}\n" +
                                    "{d|" +
                                    param.name +
                                    "}"
                                );
                            },
                            rich: {
                                a: {
                                    color: "#fff",
                                    fontSize: 14,
                                },
                                d: {
                                    color: "#A1A7B8",
                                },
                                // hr: {
                                //   borderWidth: 1,
                                //   width: "100%",
                                //   height: 0,
                                //   borderColor: "#A1A7B8",
                                // },
                            },
                        },
                        labelLine: {
                            lineStyle: {
                                color: "#A1A7B8",
                            },
                        },
                    }
                ],
            };
            return option
        }
    },
    created() {
    },
    mounted() {
    },
}
</script> 

<style lang="scss" scoped>
.TopCharts {
    width: 100%;
    height: 100%;
    @include setFlexBetween;

    .left {
        width: 170px;
        height: 150px;
    }

    .right {
        width: 250px;
        height: 150px;
    }
}
</style>